







import {Component, Vue} from "vue-property-decorator";
import RocketChat from "./RocketChat.vue";

@Component({
  components: {
    RocketChat,
  },
})
export default class ChatTab extends Vue {


}
